import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'avn/services/api.service';
import { COUNTRY_CODES } from 'avn/services/country-codes';
import { SharedCompsService } from 'avn/shared/shared-comps.service';
@Component({
  selector: 'app-exit-user-details',
  templateUrl: './exit-user-details.component.html',
  styleUrls: ['./exit-user-details.component.scss']
})
export class ExitUserDetailsComponent implements OnInit {
  countryCodes = COUNTRY_CODES;
  constructor(
    private dialogRef: MatDialogRef<ExitUserDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private fb: FormBuilder,
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private shared: SharedCompsService
  ) {}
  userForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    name: ['', [Validators.required, Validators.minLength(2), Validators.pattern(/^[a-z A-Z]+$/)]],
    phone_number: ['', [Validators.required]],
    country_code: ['+61', [Validators.required]],
    appointment_notes: [''],
    preferred_contact_method: [''],
    best_time_to_reach: ['']
  });
  showUserDetailsPopup = true;
  phoneObject: { phone_number: string; country_code: string } = { phone_number: '', country_code: '+61' };
  queryParamSub: any;
  claimNumber: any;
  methods: string[] = ['Phone', 'Email'];
  timings: string[] = ['Morning', 'Afternoon', 'Evening'];

  isEmailPreferred = false;
  isPhonePreferred = false;

  selectedService = '';
  ngOnInit(): void {
    // Read query params as a plain object (no .get())
    this.queryParamSub = this.route.queryParams.subscribe((queryParams: Params) => {
      if (queryParams && queryParams['claim_number']) {
        this.claimNumber = queryParams['claim_number'];
      }
    });

    // Extract dynamic service from the URL path: /search/:service/:location?...
    const fullPath = this.router.url.split('?')[0]; // ignore query string
    const parts = fullPath.split('/').filter(Boolean);
    const searchIdx = parts.indexOf('search');
    const serviceFromPath = searchIdx >= 0 && parts[searchIdx + 1] ? decodeURIComponent(parts[searchIdx + 1]) : '';
    if (serviceFromPath) {
      this.selectedService = serviceFromPath;
      console.info('service from path:', this.selectedService);
    }
  }
  preferredContact(e: any) {
    const value = e.value;
    this.userForm.get('preferred_contact_method')?.setValue(value);

    const emailCtrl = this.userForm.get('email');
    const phoneCtrl = this.userForm.get('phone_number');

    this.isEmailPreferred = value === 'Email';
    this.isPhonePreferred = value === 'Phone';

    if (this.isEmailPreferred) {
      emailCtrl?.enable({ emitEvent: false });
      emailCtrl?.setValidators([Validators.required, Validators.email]);
      emailCtrl?.updateValueAndValidity({ emitEvent: false });

      phoneCtrl?.clearValidators();
      phoneCtrl?.updateValueAndValidity({ emitEvent: false });
      phoneCtrl?.disable({ emitEvent: false });
    } else if (this.isPhonePreferred) {
      phoneCtrl?.enable({ emitEvent: false });
      phoneCtrl?.setValidators([Validators.required]);
      phoneCtrl?.updateValueAndValidity({ emitEvent: false });

      emailCtrl?.clearValidators();
      emailCtrl?.updateValueAndValidity({ emitEvent: false });
      emailCtrl?.disable({ emitEvent: false });
    } else {
      emailCtrl?.clearValidators();
      emailCtrl?.updateValueAndValidity({ emitEvent: false });
      phoneCtrl?.clearValidators();
      phoneCtrl?.updateValueAndValidity({ emitEvent: false });
    }
  }

  bestTimeToReach(e: any) {
    const value = e.value;
    this.userForm.get('best_time_to_reach')?.setValue(value);
  }

  phoneGroupEmit(e: FormGroup) {
    const values = e.getRawValue();
    this.userPhone?.setValue(values.phone_number);
    this.countryCode?.setValue(values.country_code);
    const currentErrors = this.userPhone?.errors || {};
    const { ...restErrors } = currentErrors;
    const customPhoneErrors = e.errors ? e.errors : null;
    const nextErrors = customPhoneErrors ? { ...restErrors, ...customPhoneErrors } : restErrors;
    this.userPhone?.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
  }

  /**
   * Submits the form data to check if the user exists
   * On success: closes dialog and navigates to home
   * On error: shows snackbar message
   */
  submiteDetails() {
    console.info(this.userForm.getRawValue());
    const params: any = this.userForm.getRawValue();
    const modality = this.selectedService.charAt(0).toUpperCase() + this.selectedService.slice(1);
    console.info('params', params);
    this.api.userExist(params, this.claimNumber, modality).subscribe({
      next: (response: any) => {
        console.info(response);
        this.showUserDetailsPopup = false;
        this.dialogRef.close();
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.info(error);
        this.shared.showSnackBar(error.error.error, 3);
      }
    });
  }

  /*** Skips the form and navigates back to home*/

  skip() {
    this.showUserDetailsPopup = false;
    this.router.navigate(['/']);
  }

  /*** Closes the Material dialog*/

  closeModal(): void {
    this.dialogRef.close();
  }

  // Form control getters
  get userEmail() {
    return this.userForm.get('email');
  }
  get userName() {
    return this.userForm.get('name');
  }
  get userPhone() {
    return this.userForm.get('phone_number');
  }
  get countryCode() {
    return this.userForm.get('country_code');
  }
}
